import { fuzzyDateParse } from "@loanlink-nl/migration";
import type { Erfpacht } from "@loanlink-nl/model-app";

export function getErfpacht(fundaProperties: any) {
	const parcels =
		fundaProperties?.find?.((p: any) => p.Id === "cadastral")?.KenmerkenList ??
		[];

	const erfpachten: Erfpacht[] = [];

	for (const parcel of parcels) {
		const fees = parcel.KenmerkenList.find(
			(p: any) => p.Id === "cadastral-fees",
		)?.Value?.toLowerCase();
		const ownershipSituation = parcel.KenmerkenList.find(
			(p: any) => p.Id === "cadastral-ownershipsituation",
		)?.Value?.toLowerCase();

		let erfpachtKind: "particulier" | "gemeente" | null = null;
		if (ownershipSituation?.includes("particulier")) {
			erfpachtKind = "particulier";
		} else if (ownershipSituation?.includes("erfpacht")) {
			erfpachtKind = "gemeente";
		}

		if (!erfpachtKind) {
			continue;
		}

		let erfpacht: Erfpacht | null = null;
		if (fees === "eeuwigdurend afgekocht") {
			erfpacht = {
				kind: erfpachtKind,
				isAfgekocht: true,
				eeuwigdurend: true,
				eeuwigdurendAfgekocht: true,
			};
		}

		if (fees?.startsWith("afgekocht tot")) {
			const endDate =
				fuzzyDateParse(fees?.split("tot")[1]?.trim()).toISODate() ?? undefined;

			erfpacht = {
				kind: erfpachtKind,
				isAfgekocht: true,
				afgekochtTot: endDate,
			};
		}

		if (fees?.startsWith("€")) {
			const [price, period] =
				fees
					?.slice(2)
					?.split("per")
					?.map((v: string) => v.trim()) ?? [];

			let priceNum = Number(price.replaceAll(".", "").replaceAll(",", "."));
			if (period.startsWith("maand")) {
				priceNum *= 12;
			}

			erfpacht = {
				kind: erfpachtKind,
				canonYearly: priceNum,
			};

			if (period.includes("met optie tot afkopen")) {
				erfpacht.canAfkopen = true;
			}
		}

		if (ownershipSituation?.includes("einddatum erfpacht:")) {
			const date = ownershipSituation.split("einddatum erfpacht:")[1].trim();

			const endDate =
				fuzzyDateParse(date.slice(0, 10)).toISODate() ?? undefined;

			erfpacht ??= {
				kind: erfpachtKind,
			};
			erfpacht.endDate = endDate;
			erfpacht.eeuwigdurend = false;
			erfpacht.eeuwigdurendAfgekocht = false;
		}

		if (erfpacht) {
			erfpachten.push(erfpacht);
		}
	}

	return erfpachten;
}
